export default "__VITE_ASSET__Cdlt4CFg__"